(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-collection-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b2b-collection-grid')) {
    customElements.define('b2b-collection-grid', class extends HTMLElement {
      connectedCallback() {
        this.products = this.querySelector('[data-b2b-products]');
        this.updateStickyOffset = () => {
          const header = document.querySelector('.header-section');
          const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
          this.style.setProperty('--b2b-collection-sticky-top', `${headerHeight + 12}px`);
        };
        this.updateStickyOffset();
        this.headerResizeObserver = new ResizeObserver(this.updateStickyOffset);
        const header = document.querySelector('.header-section');
        if (header) this.headerResizeObserver.observe(header);
        window.addEventListener('resize', this.updateStickyOffset);
        document.addEventListener('headerStickyChange', this.updateStickyOffset);
        const savedView = sessionStorage.getItem('b2bCollectionView');
        this.setView(savedView || this.dataset.defaultView || 'grid');
        this.addEventListener('click', (event) => this.handleClick(event));
        this.addEventListener('change', (event) => this.handleChange(event));
        this.addEventListener('input', (event) => this.handleSearch(event));
        this.addEventListener('submit', (event) => this.handleSubmit(event));
      }

      disconnectedCallback() {
        this.headerResizeObserver?.disconnect();
        window.removeEventListener('resize', this.updateStickyOffset);
        document.removeEventListener('headerStickyChange', this.updateStickyOffset);
      }

      handleClick(event) {
        if (event.target.closest('[data-b2b-filter-open]')) return this.toggleDrawer(true);
        if (event.target.closest('[data-b2b-filter-close]')) return this.toggleDrawer(false);
        const viewButton = event.target.closest('[data-b2b-view]');
        if (viewButton) return this.setView(viewButton.dataset.b2bView);
        const quantity = event.target.closest('.b2b-collection-card')?.querySelector('[data-card-quantity]');
        if (!quantity) return;
        const direction = event.target.closest('[data-card-minus]') ? -1 : event.target.closest('[data-card-plus]') ? 1 : 0;
        if (!direction) return;
        const step = Number(quantity.step || 1);
        const min = Number(quantity.min || 1);
        const max = Number(quantity.max || 0);
        let value = Math.max(min, Number(quantity.value || min) + (step * direction));
        if (max > 0) value = Math.min(max, value);
        quantity.value = value;
      }

      handleChange(event) {
        if (event.target.matches('[data-b2b-sort]')) return event.target.form.submit();
        if (event.target.matches('[data-b2b-filter-input]')) return event.target.form.submit();
        if (!event.target.matches('[data-card-variant]')) return;
        const card = event.target.closest('.b2b-collection-card');
        const option = event.target.selectedOptions[0];
        const quantity = card.querySelector('[data-card-quantity]');
        card.querySelector('[data-card-variant-input]').value = option.value;
        quantity.min = option.dataset.min || 1;
        quantity.step = option.dataset.step || 1;
        quantity.value = quantity.min;
        card.querySelector('[data-card-submit]').disabled = option.dataset.available !== 'true';
        const price = Number(option.dataset.price || 0);
        const compareAtPrice = Number(option.dataset.compareAtPrice || 0);
        const onSale = compareAtPrice > price;
        const wasPrice = card.querySelector('[data-card-was-price]');
        const nowLabel = card.querySelector('[data-card-now-label]');
        card.querySelector('[data-card-price-value]').textContent = this.formatMoney(price);
        wasPrice.hidden = !onSale;
        nowLabel.hidden = !onSale;
        if (onSale) wasPrice.querySelector('b').textContent = this.formatMoney(compareAtPrice);
        const margin = card.querySelector('[data-card-margin]');
        const msrp = Number(margin?.dataset.msrp || 0);
        if (margin && msrp > 0) margin.querySelector('span').textContent = `${(((msrp - price) * 100) / msrp).toFixed(1)}%`;
      }

      handleSearch(event) {
        if (!event.target.matches('[data-b2b-filter-search]')) return;
        const query = event.target.value.toLowerCase();
        event.target.closest('.b2b-collection__filter-content').querySelectorAll('[data-b2b-filter-value]').forEach((item) => {
          item.hidden = !item.textContent.toLowerCase().includes(query);
        });
      }

      async handleSubmit(event) {
        const form = event.target.closest('[data-b2b-card-form]');
        if (!form || window.theme?.settings?.cartType === 'page') return;
        event.preventDefault();
        const button = form.querySelector('[data-card-submit]');
        const error = form.querySelector('[data-card-error]');
        button.setAttribute('aria-busy', 'true');
        error.hidden = true;
        try {
          const data = new FormData(form);
          data.set('sections', 'cart-ajax');
          data.set('sections_url', window.location.pathname);
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: data });
          const json = await response.json();
          if (!response.ok) throw json;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: json, addToCartBtn: button } }));
        } catch (failure) {
          error.textContent = failure.description || 'This product could not be added.';
          error.hidden = false;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      toggleDrawer(open) {
        const drawer = this.querySelector('[data-b2b-filter-drawer]');
        if (!drawer) return;
        drawer.classList.toggle('is-open', open);
        drawer.setAttribute('aria-hidden', String(!open));
        document.documentElement.classList.toggle('lock-scroll', open);
      }

      setView(view) {
        const selected = view === 'list' ? 'list' : 'grid';
        this.products?.classList.toggle('is-list', selected === 'list');
        this.querySelectorAll('[data-b2b-view]').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.b2bView === selected)));
        sessionStorage.setItem('b2bCollectionView', selected);
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify.currency?.active || 'USD' }).format(cents / 100).replace('US$', '$');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b2b-featured-trade-products')) {
    customElements.define('b2b-featured-trade-products', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => this.handleClick(event));
        this.addEventListener('change', (event) => this.handleChange(event));
        this.addEventListener('submit', (event) => this.handleSubmit(event));
      }

      handleClick(event) {
        const carousel = this.querySelector('[data-featured-carousel]');
        const direction = event.target.closest('[data-featured-previous]') ? -1 : event.target.closest('[data-featured-next]') ? 1 : 0;
        if (direction && carousel) {
          const card = carousel.querySelector('.b2b-featured-card');
          carousel.scrollBy({ left: direction * ((card?.offsetWidth || 300) + 10), behavior: 'smooth' });
          return;
        }
        const quantity = event.target.closest('.b2b-featured-card')?.querySelector('[data-featured-quantity]');
        if (!quantity) return;
        const adjustment = event.target.closest('[data-featured-minus]') ? -1 : event.target.closest('[data-featured-plus]') ? 1 : 0;
        if (!adjustment) return;
        const step = Number(quantity.step || 1);
        const min = Number(quantity.min || 1);
        const max = Number(quantity.max || 0);
        let value = Math.max(min, Number(quantity.value || min) + (step * adjustment));
        if (max > 0) value = Math.min(max, value);
        quantity.value = value;
      }

      handleChange(event) {
        if (!event.target.matches('[data-featured-variant]')) return;
        const card = event.target.closest('.b2b-featured-card');
        const option = event.target.selectedOptions[0];
        const price = Number(option.dataset.price || 0);
        const compare = Number(option.dataset.compareAtPrice || 0);
        const onSale = compare > price;
        const quantity = card.querySelector('[data-featured-quantity]');
        card.querySelector('[data-featured-variant-input]').value = option.value;
        quantity.min = option.dataset.min || 1;
        quantity.step = option.dataset.step || 1;
        quantity.value = quantity.min;
        card.querySelector('[data-featured-submit]').disabled = option.dataset.available !== 'true';
        card.querySelector('[data-featured-price]').textContent = this.formatMoney(price);
        const was = card.querySelector('[data-featured-was]');
        const now = card.querySelector('[data-featured-now]');
        was.hidden = !onSale;
        now.hidden = !onSale;
        if (onSale) was.querySelector('b').textContent = this.formatMoney(compare);
        const margin = card.querySelector('[data-featured-margin]');
        const msrp = Number(margin?.dataset.msrp || 0);
        if (margin && msrp > 0) margin.querySelector('span').textContent = `${(((msrp - price) * 100) / msrp).toFixed(1)}%`;
      }

      async handleSubmit(event) {
        const form = event.target.closest('[data-featured-form]');
        if (!form || window.theme?.settings?.cartType === 'page') return;
        event.preventDefault();
        const button = form.querySelector('[data-featured-submit]');
        const error = form.querySelector('[data-featured-error]');
        button.setAttribute('aria-busy', 'true');
        error.hidden = true;
        try {
          const data = new FormData(form);
          data.set('sections', 'cart-ajax');
          data.set('sections_url', window.location.pathname);
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: data });
          const json = await response.json();
          if (!response.ok) throw json;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: json, addToCartBtn: button } }));
        } catch (failure) {
          error.textContent = failure.description || 'This product could not be added.';
          error.hidden = false;
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: window.Shopify.currency?.active || 'USD' }).format(cents / 100).replace('US$', '$');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-product-lower"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b2b-product-lower')) {
    customElements.define('b2b-product-lower', class extends HTMLElement {
      connectedCallback() {
        const overview = this.querySelector('[data-b2b-overview]');
        const readMore = this.querySelector('[data-b2b-read-more]');
        if (overview && readMore) {
          const label = readMore.querySelector('[data-b2b-read-label]');
          const collapsedLabel = label?.textContent || 'Read more';
          readMore.addEventListener('click', () => {
            const expanded = readMore.getAttribute('aria-expanded') === 'true';
            readMore.setAttribute('aria-expanded', String(!expanded));
            overview.classList.toggle('is-expanded', !expanded);
            if (label) label.textContent = expanded ? collapsedLabel : 'Read less';
          });
        }

      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-product-main"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b2b-product-order')) {
    customElements.define('b2b-product-order', class extends HTMLElement {
      connectedCallback() {
        this.quantity = this.querySelector('[data-b2b-quantity]');
        this.variantSelect = this.querySelector('[data-b2b-variant-select]');
        this.variantInput = this.querySelector('[data-b2b-variant-input]');
        this.submit = this.querySelector('.b2b-product-main__submit');
        this.sticky = this.querySelector('[data-b2b-sticky]');
        this.currency = this.dataset.currency || 'USD';
        this.bindQuantity('[data-b2b-minus]', '[data-b2b-plus]');
        this.bindQuantity('[data-b2b-sticky-minus]', '[data-b2b-sticky-plus]');
        this.variantSelect?.addEventListener('change', () => this.updateVariant());
        this.quantity?.addEventListener('change', () => this.normalizeQuantity());
        this.querySelector('[data-b2b-sticky-submit]')?.addEventListener('click', () => this.submit?.click());
        if (this.submit && this.sticky) {
          this.observer = new IntersectionObserver(([entry]) => {
            const visible = !entry.isIntersecting;
            this.sticky.classList.toggle('is-visible', visible);
            this.sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
          });
          this.observer.observe(this.submit);
        }
        this.updateTotals();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      bindQuantity(minusSelector, plusSelector) {
        this.querySelector(minusSelector)?.addEventListener('click', () => this.changeQuantity(-1));
        this.querySelector(plusSelector)?.addEventListener('click', () => this.changeQuantity(1));
      }

      getStep() {
        return Number(this.quantity?.step || 1);
      }

      changeQuantity(direction) {
        if (!this.quantity) return;
        const minimum = Number(this.quantity.min || 1);
        const maximum = Number(this.quantity.max || 0);
        let next = Number(this.quantity.value || minimum) + (this.getStep() * direction);
        next = Math.max(minimum, next);
        if (maximum > 0) next = Math.min(maximum, next);
        this.quantity.value = next;
        this.updateTotals();
      }

      normalizeQuantity() {
        if (!this.quantity) return;
        const minimum = Number(this.quantity.min || 1);
        const step = this.getStep();
        const maximum = Number(this.quantity.max || 0);
        let value = Number(this.quantity.value || minimum);
        value = minimum + Math.round((value - minimum) / step) * step;
        value = Math.max(minimum, value);
        if (maximum > 0) value = Math.min(maximum, value);
        this.quantity.value = value;
        this.updateTotals();
      }

      selectedVariant() {
        return this.variantSelect?.selectedOptions[0] || null;
      }

      currentPrice() {
        return Number(this.selectedVariant()?.dataset.price || this.querySelector('[data-b2b-trade-price]')?.dataset.price || 0);
      }

      updateVariant() {
        const option = this.selectedVariant();
        if (!option) return;
        this.variantInput.value = option.value;
        this.quantity.min = option.dataset.min || 1;
        this.quantity.step = option.dataset.increment || 1;
        this.quantity.value = this.quantity.min;
        this.submit.disabled = option.dataset.available !== 'true';
        const sku = this.querySelector('[data-b2b-sku]');
        const barcode = this.querySelector('[data-b2b-barcode]');
        const increment = this.querySelector('[data-b2b-increment]');
        if (sku) sku.textContent = option.dataset.sku || '';
        if (barcode) barcode.textContent = option.dataset.barcode || '';
        if (increment) increment.textContent = option.dataset.increment || '1';
        this.updateTotals();
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.currency }).format(cents / 100).replace('US$', '$');
      }

      updateTotals() {
        if (!this.quantity) return;
        const option = this.selectedVariant();
        const price = Number(option?.dataset.price || this.querySelector('[data-b2b-trade-price]')?.dataset.price || 0);
        const quantity = Number(this.quantity.value || 1);
        const priceNode = this.querySelector('[data-b2b-trade-price]');
        const compareNode = this.querySelector('[data-b2b-compare-price]');
        const pricingGrid = this.querySelector('[data-b2b-pricing-grid]');
        const totalNode = this.querySelector('[data-b2b-line-total]');
        const stickyPrice = this.querySelector('[data-b2b-sticky-price]');
        const stickyQuantity = this.querySelector('[data-b2b-sticky-quantity]');
        if (priceNode && option) {
          priceNode.dataset.price = price;
          priceNode.textContent = this.formatMoney(price);
        }
        const compareAtPrice = Number(option?.dataset.compareAtPrice || compareNode?.dataset.compareAtPrice || 0);
        const isOnSale = compareAtPrice > price;
        if (compareNode) {
          compareNode.hidden = !isOnSale;
          compareNode.dataset.compareAtPrice = compareAtPrice;
          if (isOnSale) compareNode.querySelector('strong').textContent = this.formatMoney(compareAtPrice);
        }
        pricingGrid?.classList.toggle('has-compare-price', isOnSale);
        if (totalNode) totalNode.textContent = this.formatMoney(price * quantity);
        if (stickyPrice) stickyPrice.textContent = this.formatMoney(price);
        if (stickyQuantity) stickyQuantity.textContent = quantity;
        const marginNode = this.querySelector('[data-b2b-margin]');
        const rrp = Number(marginNode?.dataset.rrpCents || 0);
        if (marginNode && rrp > 0) marginNode.textContent = `${(((rrp - price) * 100) / rrp).toFixed(1)}%`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-product-range"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b2b-product-range')) {
    customElements.define('b2b-product-range', class extends HTMLElement {
      connectedCallback() {
        const carousel = this.querySelector('[data-range-carousel]');
        const move = (direction) => {
          if (!carousel) return;
          const card = carousel.querySelector('article');
          carousel.scrollBy({ left: direction * ((card?.offsetWidth || 300) + 10), behavior: 'smooth' });
        };
        this.querySelector('[data-range-previous]')?.addEventListener('click', () => move(-1));
        this.querySelector('[data-range-next]')?.addEventListener('click', () => move(1));
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
